<template>
  <a-table
    :columns="columns"
    :row-key="(record) => record.objId"
    :data-source="data"
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
    size="middle"
  >
    <template slot="name" slot-scope="name">
      {{ name.first }} {{ name.last }}
    </template>
  </a-table>
</template>
<script>
import { userPull } from "@/api/homeApi.js";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
  },
  {
    title: "用户uid",
    align: "center",
    dataIndex: "userUid",
  },
  {
    title: "团队等级",
    align: "center",
    dataIndex: "levelName",
  },
  {
    title: "昵称",
    align: "center",
    dataIndex: "userNickName",
    sorter: true,
  },
  {
    title: "手机号码",
    align: "center",
    dataIndex: "recommendPhone",
    sorter: true,
  },
  {
    title: "贡献佣金",
    align: "center",
    dataIndex: "contributeFee",
    sorter: true,
  },
  {
    title: "推荐时间",
    align: "center",
    dataIndex: "createTime",
    sorter: true,
  },
];

export default {
  data() {
    return {
      data: [],
      loading: false,
      columns,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.getUserPull();
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      let uid = this.$route.query.uid;
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      userPull(10, this.pagination.current, uid).then((res) => {
        this.data = res.data;
        console.log(res);
      });
      this.loading = false;
    },
    getUserPull() {
      let uid = this.$route.query.uid;
      userPull(10, 1, uid).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        console.log(res);
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/memberManagement/userPullsNew/userPullsNewContent.vue